<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-row
        class="height-100"
        align="center"
        justify="center"
      >
        <v-col 
          cols="12" sm="4"
          class="text-center"
        >
          <v-toolbar-title 
            @click="$router.push('/')" style="cursor:pointer"
          >
          Tellenserver Music Tooling
          </v-toolbar-title>
        </v-col>
        <v-col 
          cols="9" sm="4"
          v-if="isTokenGranted && $route.name == 'RROOB'"
        >
          <v-menu
            ref="date_menu"
            v-model="date_menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormatted"
                label="Datum"
                prepend-icon="mdi-calendar"
                hide-details
                v-bind="attrs"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col 
          class="text-right" 
          sm="4"
          cols="3"
          v-if="isTokenGranted && $route.name == 'RROOB'"
        >
          <span>{{artists.length}} artists followed</span>
        </v-col>
        <v-spacer v-else></v-spacer>
      </v-row>
    </v-app-bar>

    <v-content>
      <router-view/>  
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import helper from './helper'

export default {
  name: 'App',
  data() {
    return {
      date_menu: null,
      dateFormatted: this.formatDate(new Date(Date.now() - (60*60*24*7*1000)).toISOString().split('T')[0]),
      date: new Date(Date.now() - (60*60*24*7*1000)).toISOString()
    }
  },
  created() {
    this.UPDATE_DATE(this.date);
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date);
      this.UPDATE_DATE(this.date);
    },
  },
  methods: {
    ...helper,
    ...mapMutations('SpotifyModule', ['UPDATE_DATE']),
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
  computed: {
    ...mapState('SpotifyModule', {
      token: state => state.token,
      artists: state => state.artists,
      albums: state => state.albums
    }),
    isTokenGranted() { return this.token?.length !== 0 }
  }
};
</script>

<style>
  .height-100 {
    height: 100% !important;
  }

  @media (max-width: 600px) {
    .v-app-bar {
      min-height: 150px !important;
    }

    .v-main {
      padding-top: 150px !important;
    }
  }
</style>
